module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vh-100 overflow-y-scroll"
  }, [_c('div', {
    staticClass: "ma2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      Go back\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around ma2"
  }, [_c('pl-button', {
    staticClass: "pl-secondary-font pl-border shadow-1",
    class: _vm.tab === 'edit_school_info' ? ['pl-secondary', 'pl-white-font'] : [],
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'edit_school_info'
      }
    }
  }, [_vm._v("\n      Edit School Information (codes, basic info)\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-secondary-font pl-border shadow-1",
    class: _vm.tab === 'manage_school_membership' ?
      ['pl-secondary', 'pl-white-font'] :
      [],
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'manage_school_membership'
      }
    }
  }, [_vm._v("\n      Edit School Memberships (payments, Memberships)\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-secondary-font pl-border shadow-1",
    class: _vm.tab === 'manage_teachers_in_school' ?
      ['pl-secondary', 'pl-white-font'] :
      [],
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'manage_teachers_in_school'
      }
    }
  }, [_vm._v("\n      Manage Teachers in School\n    ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-secondary-font pl-border shadow-1",
    class: _vm.tab === 'school_engagement_summary' ?
      ['pl-secondary', 'pl-white-font'] :
      [],
    nativeOn: {
      "click": function($event) {
        _vm.tab = 'school_engagement_summary'
      }
    }
  }, [_vm._v("\n      See School Usage Summary\n    ")])], 1), _vm._v(" "), (_vm.tab === 'edit_school_info') ? _c('edit-school-info', {
    staticClass: "ma4 mw8 center",
    attrs: {
      "schoolTitle": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 'manage_school_membership') ? _c('manage-school-membership', {
    staticClass: "ma4 mw8 center"
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 'manage_teachers_in_school') ? _c('manage-teachers-in-school', {
    staticClass: "ma4 mw8 center"
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 'school_engagement_summary') ? _c('school-engagement-summary', {
    staticClass: "ma4 mw9 center"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-58496190!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/viewIndividualSchool.vue
// module id = 1989
// module chunks = 61